import { applySocketUpdates } from 'app/gamma/src/modules/state/apply-socket-updates';
import createStore from './store';

export const defaultStore = createStore([applySocketUpdates]);
